<div class="eva-popover" [class.eva-popover--disabled]="disabled">
  <!-- Trigger -->
  <div
    class="eva-popover__trigger"
    (click)="onTriggerClick($event)"
    (mouseenter)="onTriggerMouseEnter()"
    (mouseleave)="onTriggerMouseLeave()"
    (focus)="onTriggerFocus()"
    (blur)="onTriggerBlur()"
  >
    <ng-content select="[trigger]"></ng-content>
  </div>

  <!-- Popover Panel -->
  <div
    *ngIf="isVisible"
    #popoverPanel
    class="eva-popover__panel"
    [class.eva-popover__panel--top]="position === 'top'"
    [class.eva-popover__panel--right]="position === 'right'"
    [class.eva-popover__panel--bottom]="position === 'bottom'"
    [class.eva-popover__panel--left]="position === 'left'"
    [class.eva-popover__panel--align-start]="align === 'start'"
    [class.eva-popover__panel--align-end]="align === 'end'"
    [class.eva-popover__panel--with-arrow]="arrowVisible"
    [ngStyle]="popoverStyle"
    (mouseenter)="onPopoverMouseEnter()"
    (mouseleave)="onPopoverMouseLeave()"
    role="dialog"
  >
    <!-- Arrow -->
    <div *ngIf="arrowVisible" class="eva-popover__arrow"></div>

    <!-- Header -->
    <div *ngIf="header || showClose" class="eva-popover__header">
      <span *ngIf="header" class="eva-popover__title">{{ header }}</span>
      <button *ngIf="showClose" type="button" class="eva-popover__close" (click)="hide()" aria-label="Fermer">
        <ng-icon name="heroXMark"></ng-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="eva-popover__content">
      <ng-content select="[content]"></ng-content>
    </div>

    <!-- Footer -->
    <div class="eva-popover__footer">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
